import { useEffect, useRef, useState } from "react";
import { BsCheckLg } from "react-icons/bs";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import styled from "styled-components";

import useOutsideAlert from "../../hooks/useOutsideAlert";
import { ACCENT_800, GREEN_200, GREEN_800 } from "./colors";
import FlexBox from "./FlexBox";
import { Body2 } from "./Headings";

const Container = styled(FlexBox)`
  position: relative;
  width: 100%;
`;

const DropdownOption = styled(FlexBox)`
  justify-content: space-between;
  margin: auto;
  width: 100%;
  height: 100%;
  align-items: center;
  border: 1px solid #9e9e9e;
  min-width: 10rem;
  border-radius: 0.5rem;
  padding: 0.5rem;
  color: ${ACCENT_800};
  cursor: pointer;
`;

const OptionsContainer = styled(FlexBox)`
  flex-direction: column;
  position: absolute;
  width: 100%;
  min-width: 100%;
  top: 3rem;
  right: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
`;

const Option = styled(FlexBox)`
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  white-space: nowrap;
  margin-right: auto;
  width: 100%;
  min-width: 100%;
  color: ${props => (props.selected ? GREEN_800 : ACCENT_800)};
  background-color: ${props => (props.selected ? GREEN_200 : "white")};
  &:hover {
    background-color: ${GREEN_200};
    color: ${GREEN_800};
    cursor: pointer;
  }
`;

const Dropdown = ({ options, onSelectOption }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [label, setLabel] = useState(options[0]?.label);
  const wrapperRef = useRef(null);
  useOutsideAlert(wrapperRef, () => setIsOpen(false));

  const toggleDropdown = () => {
    if (!isOpen) {
      //   trackEvent();
    }
    setIsOpen(!isOpen);
  };

  const onOptionClick = option => {
    setLabel(option.label);
    onSelectOption(option.slug);
    toggleDropdown();
  };

  return (
    <Container ref={wrapperRef}>
      <DropdownOption onClick={toggleDropdown}>
        <Body2>{label}</Body2>
        {isOpen ? (
          <IoMdArrowDropup fontSize={"1.5rem"} color={ACCENT_800} />
        ) : (
          <IoMdArrowDropdown fontSize={"1.5rem"} color={ACCENT_800} />
        )}
      </DropdownOption>

      {isOpen && (
        <OptionsContainer>
          {options.map(option => (
            <Option
              key={option.slug}
              selected={option.label === label}
              onClick={() => onOptionClick(option)}
            >
              <Body2>{option.label}</Body2>
              {option.label === label && <BsCheckLg />}
            </Option>
          ))}
        </OptionsContainer>
      )}
    </Container>
  );
};

export default Dropdown;
